import Icon from 'component/ui/Icon';
import { IconName } from 'enums/icon';
import * as React from 'react';
import { Link } from 'react-router-dom';

interface ILogo {
  url?: string | null;
}

const beeCastleLogoIcon = (
  <Icon
    name={IconName.LOGO_BEECASTLE}
    position="relative"
    width="32px"
    height="23px"
    title="Buzzby - BeeCastle Logo"
  />
);

const Logo = ({ url = '/' }: ILogo) => {
  if (url) {
    return <Link to={url}>{beeCastleLogoIcon}</Link>;
  }
  return beeCastleLogoIcon;
};

export default Logo;
